/** Convert pixel rect on a specific screenshot to percentage positioning. */
export type HotspotRect = {
  top: string;
  left: string;
  width: string;
  height: string;
};

export type TutorialImageRef = {
  width: number;
  height: number;
};

export function hotspotPx(
  rect: { x: number; y: number; w: number; h: number },
  ref: TutorialImageRef,
): HotspotRect {
  return {
    top: `${(rect.y / ref.height) * 100}%`,
    left: `${(rect.x / ref.width) * 100}%`,
    width: `${(rect.w / ref.width) * 100}%`,
    height: `${(rect.h / ref.height) * 100}%`,
  };
}

/** Intrinsic pixel sizes of web tutorial PNGs (from assets). */
export const TUTORIAL_IMAGE_REFS = {
  tacoStep1: { width: 1618, height: 1114 },
  tacoStep2: { width: 1546, height: 1114 },
  tacoStep3: { width: 1546, height: 1406 },
  burritoStep1: { width: 1618, height: 1024 },
  burritoStep2: { width: 1618, height: 1114 },
  burritoStep3: { width: 1618, height: 1114 },
  burritoStep4: { width: 1546, height: 1156 },
} as const;

/** Hotspots tuned to website screenshot dimensions (not legacy 606×902). */
export const TUTORIAL_HOTSPOTS = {
  tacoPencil: hotspotPx(
    { x: 1410, y: 750, w: 100, h: 100 },
    TUTORIAL_IMAGE_REFS.tacoStep1,
  ),
  tacoUndoChanges: hotspotPx(
    { x: 1180, y: 350, w: 220, h: 120 },
    TUTORIAL_IMAGE_REFS.tacoStep2,
  ),
  tacoSameAsTacoOne: hotspotPx(
    { x: 40, y: 835, w: 450, h: 85 },
    TUTORIAL_IMAGE_REFS.tacoStep3,
  ),
  burritoProductIntro: hotspotPx(
    { x: 28, y: 40, w: 590, h: 75 },
    TUTORIAL_IMAGE_REFS.burritoStep1,
  ),
  burritoChooseProtein: hotspotPx(
    { x: 100, y: 390, w: 1400, h: 90 },
    TUTORIAL_IMAGE_REFS.burritoStep2,
  ),
  burritoCustomizeOptions: hotspotPx(
    { x: 200, y: 520, w: 300, h: 400 },
    TUTORIAL_IMAGE_REFS.burritoStep3,
  ),
  burritoSummary: hotspotPx(
    { x: 90, y: 750, w: 1350, h: 370 },
    TUTORIAL_IMAGE_REFS.burritoStep4,
  ),
};
